module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/6-c6d27e00eed71346bcff50709f93dfec.webp";